export function throttle<T extends any[]>(originalFunction: (...args: T) => void, millisecondsLimit: number, shouldDebounce: boolean): (...args: T) => void {
  let lastCall = -1;
  let delayTimeout = -1;
  let lastContext: unknown;
  let lastArgs: T;

  return function (this: unknown, ...args: T) {
    lastContext = this;
    lastArgs = args;

    function delay(delayAmount: number) {
      window.clearTimeout(delayTimeout);

      delayTimeout = window.setTimeout(execute, delayAmount);
    }

    function execute() {
      const now = Date.now();
      const millisecondsElapsed = now - lastCall;

      if (millisecondsElapsed >= millisecondsLimit) {
        lastCall = now;
        originalFunction.apply(lastContext, lastArgs);
      } else if (shouldDebounce) {
        delay(millisecondsLimit - millisecondsElapsed);
      }
    }

    execute();
  };
}
